import SelectMulti from 'ol-ext/control/SelectMulti'
import SelectPopup from 'ol-ext/control/SelectPopup'
import Select from 'ol-ext/control/Select'
import { selectPeriod, selectPeriodTravels, } from './periodFilter'
import { itineraryEntriesData, travelsData } from './source'


export function setSelectEntriesValues(lang) {
  var values = {}
  if (lang == 'en')
    values = {
      'certain': 'certain',
      'uncertain': 'uncertain'
    }
  else
    values = {
      'certain': 'pewne',
      'uncertain': 'niepewne'
    }
  return values
}

export function setSelectSharpDatesValues(lang) {
  var values = {}
  if (lang == 'en')
    values = {
      'approximate': 'approximate',
      'precise': 'precise'
    }
  else
    values = {
      'approximate': 'przybliżona',
      'precise': 'dokładna'
    }
  return values
}

// Select date control
export const selectDate1 = new Select({
  className: 'selectDate1',
  source: itineraryEntriesData,
});
export const selectDate2 = new Select({
  className: 'selectDate2',
  source: itineraryEntriesData,
});
export const selectDate3 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});
export const selectDate4 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});
export const selectDate5 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});
export const selectDate6 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});
export const selectDate7 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});
export const selectDate8 = new Select({
  className: 'selectDate3',
  source: itineraryEntriesData,
});

export const selectDateTravel1 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel2 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel3 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel4 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel5 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel6 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel7 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});
export const selectDateTravel8 = new Select({
  className: 'selectDateTravel',
  source: travelsData,
});

export const selectCountry = new Select({
  className: 'selectCountry',
  source: itineraryEntriesData,
});

export const selectEntries = new SelectPopup({
  defaultLabel: 'all entries',
  className: 'entriesPopup',
  label: 'Entries: ',
  property: 'Cert_entry',
});

export const selectSharpDates = new SelectPopup({
  defaultLabel: 'all dates',
  className: 'datesPopup',
  label: 'Dates: ',
  property: 'Sharp_date',
});

export const selectCountRange = new SelectPopup({
  defaultLabel: 'all ranges',
  className: 'rangesPopup',
  label: 'Count entries: ',
  property: 'count_range',
});

export const filterPlaces = new SelectMulti({
  source: itineraryEntriesData,
  collapsed: true,
  target: $('.multiselect').get(0),
  btInfo: 'Filter',
  controls: [
    selectEntries,
    selectSharpDates,
    selectCountRange,
    selectCountry,
    selectDate1,
    selectDate2,
    selectDate3,
    selectDate4,
    selectDate5,
    selectDate6,
    selectDate7,
    selectDate8,
    selectPeriod,
  ]
});

export const filterTravels = new SelectMulti({
  source: travelsData,
  className: 'multiTravel',
  collapsed: false,
  noCollapse: true,
  controls: [
    selectPeriodTravels,
    selectDateTravel1,
    selectDateTravel2,
    selectDateTravel3,
    selectDateTravel4,
    selectDateTravel5,
    selectDateTravel6,
    selectDateTravel7,
    selectDateTravel8,
  ]
});

export function updateDateFilter(dateStart, dateEnd) {

  selectDate1.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDate2.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDate3.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDate4.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDate5.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDate6.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDate7.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDate8.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );


  selectDateTravel1.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDateTravel2.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDateTravel3.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDateTravel4.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDateTravel5.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDateTravel6.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateStart
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );
  selectDateTravel7.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'START_date',
      op: '<=',
      val: dateStart
    }
    ]
  }
  );
  selectDateTravel8.setConditions({
    usecase: false,
    all: false,
    conditions: [{
      attr: 'START_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '<=',
      val: dateEnd
    },
    {
      attr: 'END_date',
      op: '>=',
      val: dateEnd
    }
    ]
  }
  );

  selectDate1.doSelect({});
  selectDate2.doSelect({});
  selectDate3.doSelect({});
  selectDate4.doSelect({});
  selectDate5.doSelect({});
  selectDate6.doSelect({});
  selectDate7.doSelect({});
  selectDate8.doSelect({});
  selectDateTravel1.doSelect({});
  selectDateTravel2.doSelect({});
  selectDateTravel3.doSelect({});
  selectDateTravel4.doSelect({});
  selectDateTravel5.doSelect({});
  selectDateTravel6.doSelect({});
  selectDateTravel7.doSelect({});
  selectDateTravel8.doSelect({});

}

$(document).on('click', '.dropdown-menu', function () {
  var selected = [];
  $('.dropdown-menu input:checked').each(function () {
    selected.push($(this).attr('id'));

  });

  var conditions = []

  if (selected.length == 0) {
    conditions.push({
      attr: 'IDCountry',
      op: '!=',
      val: 'null'
    })

  } else {

    for (var i = 0; i < selected.length; i++) {
      conditions.push({
        attr: 'IDCountry',
        op: '=',
        val: selected[i]
      })
    }

  }


  selectCountry.setConditions({
    usecase: false,
    all: false,
    conditions: conditions
  }
  );
  selectCountry.doSelect({});
  filterPlaces.doSelect({});
});